import { useState, useEffect, useCallback, useMemo } from "react";
import _ from "lodash";

import { getLabel } from "../../tools/Dictionary";
import AlertModal from "../Commons/AlertModal";
import { dataValidator } from "../../tools/dataValidator";

import "./ValidationInput.css";
import { MdOutlineRemoveRedEye, MdMode } from "react-icons/md";

const ValidationInput = (props) =>
{

  //Props
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  const Validation = props.Validation;
  const Property = props.Property;
  const Loading = props.Loading;
  const OnChangeValue = props.OnChangeValue;
  const PreviewStyle = props.PreviewStyle;

  //State
  const [form, setForm] = useState([
  ]);
  const [error, setError] = useState({});
  const [modal, setModal] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Memo 
  const listValidation = useMemo(() => {
  
    let listValidation = [{
      property: "required",
      label: getLabel("ValidationInput", "Can't be empty"),
      type: "switch",
      value: false
    },
    {
      property: "max",
      label: getLabel("ValidationInput", "Maximum length"),
      type: "text",
      validation: ["required", "integer", "maxValue:1000", "minValue: 1"],
      style: {width: "80px"},
      value: 100
    },
    {
      property: "min",
      label: getLabel("ValidationInput", "Minimum length"),
      type: "text",
      hasToggle: true,
      toggle: false,
      validation: ["required", "integer", "maxValue:1000", "minValue: 1"],
      style: { width: "80px" },
      value: 1
    },
    {
      property: "maxValue",
      label: getLabel("ValidationInput", "Maximum value"),
      type: "text",
      hasToggle: true,
      toggle: false,
      validation: ["required", "max:100", "min: 1"],
      style: { width: "80px" },
      value: 100
    },
    {
      property: "minValue",
      label: getLabel("ValidationInput", "Minimum value"),
      type: "text",
      hasToggle: true,
      toggle: false,
      validation: ["required", "max:100", "min: 1"],
      style: { width: "80px" },
      value: 1
    },
    {
      property: "number",
      label: getLabel("ValidationInput", "Numbers only"),
      type: "switch",
      value: false
    },
    {
      property: "integer",
      label: getLabel("ValidationInput", "Integer numbers only"),
      type: "switch",
      value: false
    }]

    if (!Validation) return listValidation;

    return listValidation.filter(v => {
      
      return Validation.findIndex(val => val == v.property) > -1;

    });

  }
    , [Validation]);

  const loadData = useCallback((_data) =>
  {

    if (!_data) return;

    let tempForm = _.cloneDeep(listValidation);


    _data.forEach(validation => {
      
      let formattedValidation = validation.split(":");

      let currentFormIndex = tempForm.findIndex(f => f.property == formattedValidation[0]);

      switch (tempForm[currentFormIndex].type){
        case "switch":
          tempForm[currentFormIndex].value = true;
          break;
        case "text":
          tempForm[currentFormIndex].value = formattedValidation[1];
          tempForm[currentFormIndex].toggle = true;
          break;
        default:
          break;
      }

    });


    setForm(tempForm);
    setError({});

  }, [listValidation]);


  useEffect(() =>
  {

    loadData(Data);

  }, [Data, loadData]);


  const onClickSave = () =>
  {
    //Validate
    if (!onValidateField()){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      return;
    }

    //Format data in array
    let formattedValidation = [];

    form.forEach(f => {
      switch(f.type){
        case "switch": 
          if (f.value) formattedValidation.push(f.property);
          break;
        case "text":
          if (f.hasToggle && !f.toggle) break;
          formattedValidation.push(f.property + ":" + f.value);
          break;
        default:
          break;
      };
    });


    OnChangeValue(formattedValidation, Property);
    setModal(false);

  };

  const onCloseModal = () =>
  {

    setModal(false);
    loadData(Data);

  };


  const onChangeSwitch = (e, _validation, _isToggle = false ) => {

    try{

      let tempForm = _.cloneDeep(form);

      const updateIndex = tempForm.findIndex(f => f.property == _validation.property);

      //If has toggle
      if (_isToggle){
        tempForm[updateIndex].toggle = !tempForm[updateIndex].toggle;

        //If toggle is true, check for error
        if (tempForm[updateIndex].toggle){
          onValidateField(tempForm[updateIndex].property, tempForm[updateIndex].value);
        }else{
          //Otherwise remove error message
          let tempError = _.cloneDeep(error);
          tempError[tempForm[updateIndex].property] = "";
          setError(tempError);
        }
      }
      else
        tempForm[updateIndex].value = !tempForm[updateIndex].value;

      setForm(tempForm);
      

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    };

  }

  const onChangeText = (e, _validation) => {

    try
    {

      const value = e.target.value;

      onValidateField(_validation.property, value);

      let tempForm = _.cloneDeep(form);

      const updateIndex = tempForm.findIndex(f => f.property == _validation.property);

      tempForm[updateIndex].value = value;

      setForm(tempForm);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    };
  };

  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];

    let isValid = true; // Flag to track overall validity

    //const currentForm = form.filter(f => (((field && f.property == field) || (!field)) && f.validation && ((f.hasToggle && f.toggle) || !f.hasToggle)));
    const currentForm = field ? form.filter(f => f.property == field) : form.filter(f => f.validation && ((f.hasToggle && f.toggle) || !f.hasToggle));

    currentForm.forEach(f => {

      let currentValue = field ? value : f.value;

      // Validate
      currentValidation = dataValidator([
        { field: f.property, value: currentValue, listValidation: f.validation }
      ]);

      Validation = [...Validation, ...currentValidation];
    });

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };

  const displayModal = () =>
  {

    if (!modal) return null;

    return (
      <div className="page_modal_background">
        <div className="page_modal_cont" style={{ width: "700px" }}>
          <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
            {getLabel("ValidationInput", (ReadOnly ? "Display" : "Edit"))}
          </div>
          <div className="page_modal_body_cont" style={{ padding: "10px" }}>
            {form.map((f, index) => (
              <div className="page_modal_body_row" key={index}>
                <div className="page_modal_body_col_title" >
                  {f.label}
                </div>
                {displayInput(f)}
              </div>
            ))}
          </div>

          <div className="page_modal_footer_cont">
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Close")}
              style={{ backgroundColor: "grey", maxWidth: "200px" }}
              onClick={onCloseModal}
              disabled={Loading}
            />
            {!ReadOnly &&
              <input
                type="button"
                className="page_button page_modal_footer_button"
                value={getLabel("App", "Confirm")}
                style={{ maxWidth: "200px" }}
                onClick={onClickSave}
                disabled={Loading}
              />
            }
          </div>
        </div>
      </div>
    );

  };

  const displayInput = (_validation) =>
  {

    switch (_validation.type)
    {
      case "switch":
        return (
          <div className="page_modal_body_col_value">
            <label className="page_switch">
              <input
                type="checkbox"
                checked={_validation.value || false}
                disabled={ReadOnly || Loading}
                onChange={(e) => onChangeSwitch(e, _validation)}
              />
              <span className="page_slider round" />
            </label>
          </div>
        );
      case "text":
        return (
          <div className="page_modal_body_col_value">
            <div className="validationinput_value_cont">
              {_validation.hasToggle &&
                <label className="page_switch" style={{marginRight: "5px", marginBottom: "5px"}}>
                  <input
                    type="checkbox"
                    checked={_validation.toggle || false}
                    disabled={ReadOnly || Loading}
                    onChange={(e) => onChangeSwitch(e, _validation, true)}
                  />
                  <span className="page_slider round" />
                </label>
              }
              <input
                className={"page_text_input " + (error[_validation.property] ? "page_modal_body_col_input_error" : "")}
                value={(!_validation.hasToggle || _validation.toggle) ? (_validation.value || "") : ""}
                onChange={(e) => onChangeText(e, _validation)}
                style={_validation.style}
                disabled={ReadOnly || Loading || (_validation.hasToggle && !_validation.toggle)}
              />
            </div>
            {error[_validation.property] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error[_validation.property]}
              </div>
            }
          </div>
        );
      default:
        return null;
    }
  };


  const displayValue = (_validation, _index) => {

    switch (_validation.type){
      case "switch":
        if (!_validation.value) return null;
        return (
          <div className="validationinput_preview_item" key={_index}>
            {_validation.label}
          </div>         
        );
      case "text":
        if (_validation.hasToggle && !_validation.toggle) return null;
        return (
          <div className="validationinput_preview_item" key={_index}>
            {_validation.label} : <span>{_validation.value}</span>
          </div>
        );
      default: 
          return null;
    }

  };


  if (!Data || !form) return null;


  return (
    <div className="validationinput_cont">
      {displayModal()}
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="validationinput_preview_cont">
        <div className="validationinput_preview_item_cont" style={PreviewStyle}>
          {form.map((f, index) => (
            displayValue(f, index)
          ))}
        </div>
        <div className="page_button"
          style={{ width: "180px", height: "30px", fontSize: "20px", marginRight: "5px" }}
          title={getLabel("LabelInput", (ReadOnly ? "Display" : "Edit"))}
          onClick={() => setModal(true)}
        >
          <div className="validationinput_preview_col" style={{ width: "30%" }}>
            {ReadOnly ? <MdOutlineRemoveRedEye /> : <MdMode />}
          </div>
          <div className="validationinput_preview_col" style={{ width: "70%" }}>
            {getLabel("LabelInput", (ReadOnly ? "Display" : "Edit"))}
          </div>
        </div>

      </div>
    </div>
  );
}

export default ValidationInput;